import { atom } from "recoil";
export const showReviewState = atom({
  key: "showReviewState",
  default: false,
});